/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supported_Format_CcprjInputs */

const en_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported format: .ccprj`)
};

const fr_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format pris en charge : .ccprj`)
};

const de_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstütztes Format: .ccprj`)
};

const it_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato supportato: .ccprj`)
};

const ru_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживаемый формат: .ccprj`)
};

const es_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato admitido: .ccprj`)
};

const zh_cn2_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持的格式：.ccprj`)
};

const ja_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートされている形式: .ccprj`)
};

const hi_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समर्थित प्रारूप: .ccprj`)
};

const pt_pt2_supported_format_ccprj = /** @type {(inputs: Supported_Format_CcprjInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato suportado: .ccprj`)
};

/**
* | output |
* | --- |
* | "Supported format: .ccprj" |
*
* @param {Supported_Format_CcprjInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const supported_format_ccprj = /** @type {((inputs?: Supported_Format_CcprjInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supported_Format_CcprjInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_supported_format_ccprj(inputs)
	if (locale === "de") return de_supported_format_ccprj(inputs)
	if (locale === "it") return it_supported_format_ccprj(inputs)
	if (locale === "ru") return ru_supported_format_ccprj(inputs)
	if (locale === "es") return es_supported_format_ccprj(inputs)
	if (locale === "zh-CN") return zh_cn2_supported_format_ccprj(inputs)
	if (locale === "ja") return ja_supported_format_ccprj(inputs)
	if (locale === "hi") return hi_supported_format_ccprj(inputs)
	if (locale === "pt-PT") return pt_pt2_supported_format_ccprj(inputs)
	return en_supported_format_ccprj(inputs)
});